import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, SignIn } from "@phosphor-icons/react";

/**
 * "Sign In to View" wall shown to guests in place of locked content
 * (factory videos, downloadable documents).
 */
export default function GuestGate({ label = "Sign in to view", note, testId = "guest-gate" }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid={testId}
      className="mt-6 border border-dashed border-zinc-300 bg-zinc-50 p-8 flex flex-col items-center text-center"
    >
      <div className="w-12 h-12 grid place-items-center bg-zinc-900 text-[#FF5A1F] rounded-full mb-3">
        <Lock size={22} weight="fill" />
      </div>
      <div className="font-display text-lg font-bold text-zinc-900">{label}</div>
      {note && <p className="mt-1 text-sm text-zinc-500 max-w-sm">{note}</p>}
      <button
        onClick={() => navigate("/")}
        data-testid={`${testId}-signin`}
        className="mt-4 inline-flex items-center gap-2 bg-[#FF5A1F] hover:bg-[#E04814] text-white px-6 py-3 font-medium transition-colors"
      >
        <SignIn size={18} weight="bold" /> Sign In to View
      </button>
    </div>
  );
}
